import State from "slotworks/state-machine/states/state";
import { parallel, sequence } from "slotworks/utils/race-utils";
import HarleyComponents from "components/components";
import Layers from "slotworks/graphics/layers/layers";
import Contract from "slotworks/utils/contract";
import Components from "slotworks/components/components";
import betModel from "slotworks/model/bets/bet-model";
import { BetBarType } from "slotworks/components/betbar/bet-bar-component";

export default class RecoveryFreespinsWheel extends State {

    public onEnter() {
        Components.betBar.setBetOptions(betModel.generateBetOptions());
        Components.betBar.setType(BetBarType.FREESPINS);

        HarleyComponents.harley.showIdleFreespins();
        sequence([
            () => parallel([
                () => Layers.Background.setScene("freespins"),
                () => hideLayers([
                    Layers.MatrixBackground,
                    Layers.MatrixContent,
                    Layers.MatrixForeground,
                    Layers.SymbolAnimations,
                    Layers.BetBar,
                    Layers.SmartButton,
                    Layers.Banners,
                    Layers.Footer,
                    Layers.Custom.get("BonusBuyButton"),
                    Layers.Custom.get("Messages"),
                    Layers.Custom.get("MatrixAnim"),
                    Layers.Custom.get("MatrixNeon"),
                ]),
                () => showLayers([
                    Layers.Bonus,
                    Layers.BonusForeground
                ]),
            ]),
            () => HarleyComponents.freespinsIntro.recover(),
        ]).then(() => super.complete());
    }

}

function hideLayers(layers: Layers[]) {
    return new Contract(resolve => {
        for (let layer of layers) {
            layer.hide();
        }
        resolve(null);
    });
}

function showLayers(layers: Layers[]) {
    return new Contract(resolve => {
        for (let layer of layers) {
            layer.hide();
        }
        resolve(null);
    });
}